import './ScrollToTopFab.css';

import React from 'react';

export interface ScrollToTopFabProps {
  visible: boolean;
  onPress: () => void;
  /** Accessible name for the control (default: scroll to top). */
  ariaLabel?: string;
}

const ScrollToTopFab: React.FC<ScrollToTopFabProps> = ({
  visible,
  onPress,
  ariaLabel = 'Scroll to top',
}) => {
  return (
    <button
      type="button"
      className={[
        'scroll-to-top-fab',
        visible ? 'scroll-to-top-fab--visible' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={onPress}
      aria-label={ariaLabel}
      tabIndex={visible ? 0 : -1}
    >
      <svg
        className="scroll-to-top-fab-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <polyline
          points="18,15 12,9 6,15"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default ScrollToTopFab;
